/*
  Accordion: any button with [data-ps-acc] toggles aria-expanded; CSS reveals
  the panel it controls. Answers stay in the DOM when collapsed. If the
  button sits in a [data-ps-acc-single] group, opening one closes the rest.
*/
(function () {
  'use strict';
  // Several sections on one page each load this file; a second listener
  // would toggle every click straight back, so install it once.
  if (window.psAccordionReady) return;
  window.psAccordionReady = true;
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-ps-acc]');
    if (!btn) return;
    var open = btn.getAttribute('aria-expanded') === 'true';
    var group = btn.closest('[data-ps-acc-single]');
    if (group && !open) {
      group.querySelectorAll('[data-ps-acc][aria-expanded="true"]').forEach(function (b) {
        if (b !== btn) b.setAttribute('aria-expanded', 'false');
      });
    }
    btn.setAttribute('aria-expanded', String(!open));
  });
})();
